import type { EditorState } from '@tiptap/pm/state';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Node_Type } from 'ricos-schema';

export const createRemoveTextWrapForListItemChildrenPlugin = () => {
  return new Plugin({
    key: new PluginKey('remove-text-wrap-for-list-item-children'),
    appendTransaction: (_, _oldState: EditorState, newState: EditorState) => {
      if (newState.doc === _oldState.doc) {
        return;
      }
      const tr = newState.tr;

      tr.doc.descendants((node, pos) => {
        if (node.type.name !== Node_Type.LIST_ITEM) {
          return;
        }

        node.forEach((child, childPos) => {
          if (!child.attrs.containerData) {
            return false;
          }

          tr.setNodeAttribute(childPos + pos + 1, 'containerData', {
            ...child.attrs.containerData,
            textWrap: false,
          });
        });
      });
      return tr;
    },
  });
};
